var utils = require('../utils');
var sequence = require('./surveys-update-sequence');
var navigation = require('./surveys-navigation');
var survey = require('./surveys-update-survey');
var submission = require('../../responses/actions/post-responses');
var fetchActions = require('./surveys-fetch');

var FetchNextQuestion = (function() {

    var _fetchNextQuestion = function(fieldName, response) {
        return function(dispatch, getState) {
            var history = getState().surveys;
            var entities = getState().entities;
            var surveys = entities.surveys;
            var fields = entities.fields;
            var token = getState().auth.token;

            dispatch(navigation.checkNavigation(fields, fieldName, response));
            var surveyId = utils.getSurveyId(history, history.currentSurveyIndex);

            if (history.currentSequenceIndex + 1 < utils.getSequenceLength(surveys, surveyId)) {
                for (var i = history.currentSequenceIndex + 1; i <= utils.getSequenceLength(surveys, surveyId); i++) {
                    if (i === utils.getSequenceLength(surveys, surveyId)) { // sequence done
                        if (history.currentSurveyIndex + 1 < utils.getSurveysLength(history.index)) {
                            dispatch(_moveToNextSurvey());
                        } else {
                            dispatch(submission.postSubmission(token));
                        }
                    }else{
                        var sequenceId = utils.getSequenceId(surveys, surveyId, i);
                        var currentSequence = utils.getCurrentSequence(entities.sequences, sequenceId);
                        if (currentSequence.enabled === true) {
                            dispatch(sequence.updateSequenceIndex(i));
                            break;
                        }
                    }
                }
            } else if (history.currentSurveyIndex + 1 < utils.getSurveysLength(getState().surveys.index)) { // instead of `history.index`, it may be old, cause checkNavigation did excute before
                dispatch(fetchActions.fetchSurveysIfNeeded(getState().surveys.index.join(), getState().auth.token)).then(function() {
                    dispatch(_moveToNextSurvey());
                });
            } else {
                dispatch(submission.postSubmission(token));
            }
        };
    }

    var _moveToNextSurvey = function() {
        return function(dispatch, getState) {
            var history = getState().surveys;
            var entities = getState().entities;
            var surveys = entities.surveys;

            if(Object.keys(history.error).length > 0){
                return;
            }
            
            var nextSurveyIndex = utils.getNextSurveyIndex(history);
            
            dispatch(sequence.updateSequenceIndex(0));
            dispatch(survey.updateSurveyIndex(nextSurveyIndex));
            
            // Skip logic in case first question(s) of new survey are disabled 
            var surveyId = utils.getSurveyId(history, nextSurveyIndex);
            for (var i = 0; i <= utils.getSequenceLength(surveys, surveyId); i++) {
                var sequenceId = utils.getSequenceId(surveys, surveyId, i);
                var currentSequence = utils.getCurrentSequence(entities.sequences, sequenceId);

                if (currentSequence.enabled === true) {
                    dispatch(sequence.updateSequenceIndex(i));
                    break;
                }         
            }
        };
    }

    return {
        fetchNextQuestion: _fetchNextQuestion
    }
})();

module.exports = FetchNextQuestion;



// WEBPACK FOOTER //
// ./src/common/modules/survey/actions/fetch-next-question.js